/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Linestring } from "./Linestring";
import {
  LinestringFromJSON,
  LinestringFromJSONTyped,
  LinestringToJSON,
  LinestringToJSONTyped,
} from "./Linestring";

/**
 *
 * @export
 * @interface WaterLevelProfileRequest
 */
export interface WaterLevelProfileRequest {
  /**
   *
   */
  geometry: Linestring;
  /**
   * Maximum number of points to return
   */
  pointsLimit?: number;
  /**
   * Subscribe for new results during simulation
   */
  subscribe: boolean;
  /**
   * Max number of items per second for subscription
   */
  subscribeRateLimit?: number;
}

/**
 * Check if a given object implements the WaterLevelProfileRequest interface.
 */
export function instanceOfWaterLevelProfileRequest(
  value: object
): value is WaterLevelProfileRequest {
  if (!("geometry" in value) || value["geometry"] === undefined) return false;
  if (!("subscribe" in value) || value["subscribe"] === undefined) return false;
  return true;
}

export function WaterLevelProfileRequestFromJSON(json: any): WaterLevelProfileRequest {
  return WaterLevelProfileRequestFromJSONTyped(json, false);
}

export function WaterLevelProfileRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WaterLevelProfileRequest {
  if (json == null) {
    return json;
  }
  return {
    geometry: LinestringFromJSON(json["geometry"]),
    pointsLimit: json["points_limit"] == null ? undefined : json["points_limit"],
    subscribe: json["subscribe"],
    subscribeRateLimit:
      json["subscribe_rate_limit"] == null ? undefined : json["subscribe_rate_limit"],
  };
}

export function WaterLevelProfileRequestToJSON(json: any): WaterLevelProfileRequest {
  return WaterLevelProfileRequestToJSONTyped(json, false);
}

export function WaterLevelProfileRequestToJSONTyped(
  value?: WaterLevelProfileRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    geometry: LinestringToJSON(value["geometry"]),
    points_limit: value["pointsLimit"],
    subscribe: value["subscribe"],
    subscribe_rate_limit: value["subscribeRateLimit"],
  };
}
